import * as React from 'react'
import Head from 'next/head'

export interface PreloadTagsProps {
  preloadImages: string[]
}

export const PreloadTags: React.FunctionComponent<PreloadTagsProps> = (
  props,
) => (
  <Head>
    {props.preloadImages.map((image, index) => (
      <link
        rel="preload"
        href={image}
        key={`preload_product_image_${index}`}
        as="image"
      />
    ))}
  </Head>
)
